import { Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { InfoModalOnboarding } from '../info-modal/info-modal';
import { MatDialog } from '@angular/material/dialog';
import { ConfirmDialog } from 'src/app/layout/dialog.component';
import { Router } from '@angular/router';
import { MatSnackBar } from '@angular/material/snack-bar';
import { SettingsService } from 'src/app/settings/settings.service';


@Component({
  selector: 'app-carga-documentacion',
  standalone: false,
  templateUrl: './carga-documentacion.component.html',
  styleUrl: './carga-documentacion.component.less',
})
export class CargaDocumentacionComponent implements OnInit{
  step: any = 1;
  documentos = [
    { id: 'escritura_constitucion', nombre: 'Escritura de constitución de la sociedad', archivo: null, nombreArchivo: '' },
    { id: 'extracto_escritura', nombre: 'Extracto de la escritura de constitución', archivo: null, nombreArchivo: '' },
    { id: 'inscripcion_constitucion', nombre: 'Copia de la inscripción de constitución de sociedad', archivo: null, nombreArchivo: '' },
    { id: 'certificado_vigencia', nombre: 'Certificado de Vigencia de la sociedad', archivo: null, nombreArchivo: '' },
    { id: 'publicacion_diario', nombre: 'Publicación en Diario Oficial', archivo: null, nombreArchivo: '' },
    { id: 'protocolizacion', nombre: 'Protocolización', archivo: null, nombreArchivo: '' }
  ]; 
  isLoading!: boolean;

  isDragOver: boolean = false;
  uploadedFiles: File[] = [];
  @ViewChild('fileInput') fileInput!: ElementRef;
  id_company=localStorage.getItem('company_id');

  @Input() initialStep: number = 1;
  @Input() esEmpresaEnUnDia!: boolean;

  constructor(
    public dialog: MatDialog, 
    private router: Router,
    public snackbar: MatSnackBar,
    private settings: SettingsService
  ){

  }

  ngOnInit() {
    this.step = this.initialStep;
    this.esEmpresaEnUnDia = this.esEmpresaEnUnDia;
  }

  open_modal_info(step: any) {
    let dialogRef = this.dialog.open(InfoModalOnboarding, {
      width: '700px',
      autoFocus: false,
    });

    dialogRef.componentInstance.step = step;

    dialogRef.afterClosed().subscribe(result => {
      console.log(result)
      if(result == 'continue_documentacion'){
        this.step = 2;
      }
    
    });

  }

  onFileSelected(event: any, documento: any): void {
    const file = event.target.files[0];
    
    documento.error = null;
    
    if (file) {
      const fileExt = file.name.split('.').pop().toLowerCase();
      
      if (['pdf', 'jpg', 'jpeg', 'png', 'heic', 'heif'].includes(fileExt)) {
        documento.archivo = file;
        documento.nombreArchivo = file.name;
      } else {
        documento.error = 'El formato del archivo no es válido. Solo se permiten PDF, JPG y PNG.';
        event.target.value = '';
      }
    } else {
      documento.archivo = null;
      documento.nombreArchivo = '';
    }
  }
  

  async finalizarCarga(): Promise<void> {
    try {
      this.isLoading = true;
      const formData = new FormData();
      const archivosAgregados = {};
      
      this.documentos.forEach(doc => {
        if (doc.archivo) {
          formData.append(doc.id, doc.archivo);
          (archivosAgregados as {[key: string]: string})[doc.id] = doc.nombreArchivo;
        }
      });
      
      console.log('Archivos que se enviarán:', archivosAgregados);
      console.log('Enviando archivos:', formData);

      this.put_step(8);
      this.step = 4;
      
      // 
      
    } catch (error) {
      console.error('Error al cargar documentos:', error);
    } finally {
      this.isLoading = false;
    }
  }

  deleteFile(documento: any): void {
    documento.archivo = null;
    documento.nombreArchivo = '';
  }

  allDocumentsUploaded(): boolean {
    return this.documentos.every(doc => doc.archivo !== null);
  }

  
  //drag & drop
  onDragOver(event: DragEvent): void {
    event.preventDefault();
    this.isDragOver = true;
  }

  onDragLeave(): void {
    this.isDragOver = false;
  }

  onFileDrop(event: DragEvent): void {
    event.preventDefault();
    this.isDragOver = false;
    
    if (event.dataTransfer?.files) {
      this.processFiles(event.dataTransfer.files);
    }
  }

  onFileSelect(event: Event): void {
    const input = event.target as HTMLInputElement;
    if (input.files) {
      this.processFiles(input.files);
    }
  }

  processFiles(files: FileList): void {
    let invalidTypeCount = 0;
  
    for (let i = 0; i < files.length; i++) {
      const file = files[i];
      const fileExt = file.name.split('.').pop()?.toLowerCase();
      
      if (fileExt && ['pdf', 'jpg', 'jpeg', 'png', 'heic', 'heif'].includes(fileExt)) {
        if (!this.uploadedFiles.some(f => f.name === file.name)) {
          this.uploadedFiles.push(file);
        } 
      } else {
        invalidTypeCount++;
      }
    }
  
    if (invalidTypeCount > 0) {
      this.snackbar.open(
        `${invalidTypeCount} ${invalidTypeCount === 1 ? 'archivo no tiene un formato válido' : 'archivos no tienen un formato válido'}. Solo se permiten PDF, JPG y PNG.`, 
        'X', 
        { duration: 3000, panelClass: 'simpli-snack-onboarding' }
      );
    }
  
  }  
  
  triggerFileInput(): void {
    this.fileInput.nativeElement.click();
  }

  removeFile(file: File, event: Event): void {
    event.stopPropagation();
    this.uploadedFiles = this.uploadedFiles.filter(f => f !== file);
  }

  async finalizarCargaMasiva(): Promise<void> {
    try {
      this.isLoading = true;
      const formData = new FormData();
      
      this.uploadedFiles.forEach((file, index) => {
        formData.append(`file_${index}`, file);
      });
      
      console.log('Archivos que se enviarán:', this.uploadedFiles.map(f => f.name));
      console.log('Enviando archivos:', formData);

      // 
      
      
      this.put_step(8);
      this.step = 4;
      
    } catch (error) {
      console.error('Error al cargar documentos:', error);
     
    } finally {
      this.isLoading = false;
    }
  }


  isImageFile(file: File): boolean {
    const imageTypes = ['image/jpeg', 'image/jpg', 'image/png', 'image/heic', 'image/heif'];
    return imageTypes.includes(file.type);
  }

  isPdfFile(file: File): boolean {
    return file.type === 'application/pdf';
  }

  selectedOption: string = '';
  logout() {
    let dialogRef = this.dialog.open(ConfirmDialog, {
      autoFocus: false,
    });
    dialogRef.afterClosed().subscribe((result:any) => {
      this.selectedOption = result;

      if (this.selectedOption == 'Y') {
        localStorage.removeItem('token');
        localStorage.removeItem('role');
        localStorage.removeItem('device_token')
        this.router.navigateByUrl('/login');
      }
    });
  }

  async put_step(stepValue: number = 0, id_simulation?:any){
    try {

      let payload:any = {
        "step": stepValue
      };

      if(id_simulation){
        payload['simulation_id'] = id_simulation;
      }

      const bd: any = await this.settings.get_query(3, `onboarding/guardar-paso-company/${this.id_company}/`, payload );
      var body_data: any = bd._body;

      console.log(`Paso ${stepValue} actualizado exitosamente`);

    } catch (bd:any) {
      console.error('Error al actualizar el paso');
    }
  }
}
